import ProductSeries from '@/models/loyaltyPanel/ProductSeries';
const getDefaultState = () => ({
  products: [],
  totalPagesLength: 1,
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setProducts(state, payload) {
      state.products = payload;
    },

    updateList(state, payload) {
      state.products = payload;
    },

    setTotalPagesLength(state, payload) {
      state.totalPagesLength = payload;
    },
  },

  actions: {
    async getItems({ commit }, query) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await ProductSeries.get(query);

        commit('setProducts', data.data.products);
        commit('setTotalPagesLength', data.data.pagination.total_pages);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async updateSorting({ commit }, products) {
      try {
        commit('setLoading', true, { root: true });

        let updatingData = {
          sorting: [],
        };

        let productOrder = 1;

        products.map((product) => {
          updatingData.sorting.push({
            product_id: product.product_id,
            order: productOrder,
          });
          productOrder++;
        });

        const { data } = await ProductSeries.update(updatingData);

        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated product order!',
          },
          { root: true }
        );

        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response.data.message,
          },
          { root: true }
        );
        console.error(ex.response.data);
      }
    },
  },
};
